import {
  Create,
  SimpleForm,
  ReferenceInput,
  SelectInput,
  AutocompleteArrayInput,
  useNotify,
  useRedirect,
} from "react-admin";
import { useEffect, useState } from "react";
import { apiUrl } from "../../apiendpoint";

export const RolePermissionCreate = () => {
  const notify = useNotify();
  const redirect = useRedirect();
  const [permissions, setPermissions] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem("access_token");

    if (!token) {
      notify("Not authenticated", { type: "warning" });
      return;
    }

    fetch(`${apiUrl}permissions/all`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error();
        return res.json();
      })
      .then((data) => {
        setPermissions(
          data.map((p) => ({
            id: p.id,
            name: p.name,
          }))
        );
      })
      .catch(() =>
        notify("Failed to load permissions", { type: "error" })
      );
  }, [notify]);

  return (
    <Create
      title="Assign Role to Permission"
      mutationOptions={{
        onSuccess: () => {
          notify("Role permissions created successfully", { type: "success" });
          redirect("list", "rolepermissions"); // ✅ redirect
        },
        onError: () => {
          notify("Error creating role permissions", { type: "error" });
        },
      }}
    >
      <SimpleForm>
        <ReferenceInput source="role_id" reference="roles" label="Role">
          <SelectInput optionText="name" />
        </ReferenceInput>

        <AutocompleteArrayInput
          source="permission_id"
          label="Permissions"
          choices={permissions}
          optionText="name"
          optionValue="id"
          fullWidth
        />
      </SimpleForm>
    </Create>
  );
};